import { api } from './api';
import type {
  OAuthProvider,
  OAuthConfigsListResponse,
  OAuthConfigResponse,
  TestConnectionResponse,
  RedirectUriResponse,
  BulkImportResponse,
  DeleteOAuthConfigResponse,
  CreateOAuthConfigRequest,
  UpdateOAuthConfigRequest,
  BulkImportRequest,
} from '../types/oauth';

// OAuth Configuration endpoints
export const oauthApi = {
  // List all OAuth configurations for a project
  list: (projectId: string) =>
    api.get<OAuthConfigsListResponse>(`/api/projects/${projectId}/oauth-configs`),

  // Get a specific provider configuration
  get: (projectId: string, provider: OAuthProvider) =>
    api.get<OAuthConfigResponse>(`/api/projects/${projectId}/oauth-configs/${provider}`),

  // Create a new OAuth configuration
  create: (projectId: string, data: CreateOAuthConfigRequest) =>
    api.post<OAuthConfigResponse>(`/api/projects/${projectId}/oauth-configs`, data),

  // Update an existing OAuth configuration
  update: (projectId: string, provider: OAuthProvider, data: UpdateOAuthConfigRequest) =>
    api.put<OAuthConfigResponse>(`/api/projects/${projectId}/oauth-configs/${provider}`, data),

  // Delete an OAuth configuration
  delete: (projectId: string, provider: OAuthProvider) =>
    api.delete<DeleteOAuthConfigResponse>(`/api/projects/${projectId}/oauth-configs/${provider}`),

  // Test OAuth connection
  testConnection: (projectId: string, provider: OAuthProvider) =>
    api.post<TestConnectionResponse>(`/api/projects/${projectId}/oauth-configs/${provider}/test`),

  // Get redirect URI for a provider
  getRedirectUri: (projectId: string, provider: OAuthProvider) =>
    api.get<RedirectUriResponse>(`/api/projects/${projectId}/oauth-redirect-uri?provider=${provider}`),

  // Bulk import OAuth configurations
  bulkImport: (projectId: string, data: BulkImportRequest) =>
    api.post<BulkImportResponse>(`/api/projects/${projectId}/oauth-configs/bulk`, data),
};
